import {ActionReducerMap, Action} from '@ngrx/store';

import * as actionsUi from './mandantenverwaltung-einstellungen.actions.ui';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {Bild, LizenzMandantOptions, MandantInfo, MandantStammOptions} from '../../../clients/api';
import {VorlagenMandantOptions} from '../../../clients/vorlagen';
import {Meldeart, VeranstaltungenMandantOptions} from '../../../clients/veranstaltungen';
import {PandemieMandantOptions} from '../../../clients/pandemie';
import {IncidentsAnzeigeMandantOptions} from '../../../clients/incidents';
import {GET_MANDANT_CONFIG, GET_MANDANT_CONFIG_ERFOLGREICH, GET_MANDANT_CONFIG_FEHLER, GET_MANDANT_LOGO_BASE64_SCALED, GET_MANDANT_LOGO_BASE64_SCALED_ERFOLGREICH, GET_MANDANT_LOGO_BASE64_SCALED_FEHLER, GetMandantConfigErfolgreichAction, GetMandantLogoBase64ScaledErfolgreichAction} from '../../../client-ngrx/api';
import {MandantenConfigTypes, PandemieConfigTypes, VeranstaltungConfigTypes, VorlagenConfigTypes, IncidentsConfigTypes} from '../../../client-constants';
import MANDANT_STAMM_OPTIONS = MandantenConfigTypes.MANDANT_STAMM_OPTIONS;
import LIZENZ_MANDANT_OPTIONS = MandantenConfigTypes.LIZENZ_MANDANT_OPTIONS;
import MANDANT_INFO = MandantenConfigTypes.MANDANT_INFO;
import VORLAGEN_MANDANT_OPTIONS = VorlagenConfigTypes.VORLAGEN_MANDANT_OPTIONS;
import VERANSTALTUNGEN_MANDANT_OPTIONS = VeranstaltungConfigTypes.VERANSTALTUNGEN_MANDANT_OPTIONS;
import PANDEMIE_MANDANT_OPTIONS = PandemieConfigTypes.PANDEMIE_MANDANT_OPTIONS;
import INCIDENTS_ANZEIGE_MANDANT_OPTIONS = IncidentsConfigTypes.INCIDENTS_ANZEIGE_MANDANT_OPTIONS;

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    mandantConfigLaden: boolean;
    mandantConfigFehler: boolean;

    stammConfig: MandantStammOptions;
    lizenzConfig: LizenzMandantOptions;
    mandantId: MandantInfo;
    vorlagenConfig: VorlagenMandantOptions;
    veranstaltungenConfig: VeranstaltungenMandantOptions;
    pandemieConfig: PandemieMandantOptions;

    incidentAnzeigeConfig: IncidentsAnzeigeMandantOptions;

    selectedMeldeart: Meldeart;

    mandantLogo: Bild;
    mandantLogoLaden: boolean;
    mandantLogoFehler: boolean;
}

export const initialPageState: PageState = {
    mandantConfigLaden: false,
    mandantConfigFehler: false,

    stammConfig: null,
    lizenzConfig: null,
    mandantId: null,
    vorlagenConfig: null,
    veranstaltungenConfig: null,
    pandemieConfig: null,

    incidentAnzeigeConfig: null,

    selectedMeldeart: null,

    mandantLogo: null,
    mandantLogoLaden: false,
    mandantLogoFehler: false,
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        case GET_MANDANT_CONFIG: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: true,
                mandantConfigFehler: false,
                selectedMeldeart: null
            });
        }

        case GET_MANDANT_CONFIG_ERFOLGREICH: {
            const a = <GetMandantConfigErfolgreichAction> action;

            // console.log('Mandant Config erfolgreich: ', a);

            let stammConfig: MandantStammOptions = Object.assign({}, state.stammConfig);
            if (a.payload[MANDANT_STAMM_OPTIONS] !== undefined && a.payload[MANDANT_STAMM_OPTIONS] !== null) {
                stammConfig = a.payload[MANDANT_STAMM_OPTIONS];
            }

            let lizenzConfig: LizenzMandantOptions = Object.assign({}, state.lizenzConfig);
            if (a.payload[LIZENZ_MANDANT_OPTIONS] !== undefined && a.payload[LIZENZ_MANDANT_OPTIONS] !== null) {
                lizenzConfig = a.payload[LIZENZ_MANDANT_OPTIONS];
            }

            let mandantId: MandantInfo = Object.assign({}, state.mandantId);
            if (a.payload[MANDANT_INFO] !== undefined && a.payload[MANDANT_INFO] !== null) {
                mandantId = a.payload[MANDANT_INFO];
            }

            let vorlagenConfig: VorlagenMandantOptions = Object.assign({}, state.vorlagenConfig);
            if (a.payload[VORLAGEN_MANDANT_OPTIONS] !== undefined && a.payload[VORLAGEN_MANDANT_OPTIONS] !== null) {
                vorlagenConfig = a.payload[VORLAGEN_MANDANT_OPTIONS];
            }

            let veranstaltungenConfig: VeranstaltungenMandantOptions = Object.assign({}, state.veranstaltungenConfig);
            if (a.payload[VERANSTALTUNGEN_MANDANT_OPTIONS] !== undefined && a.payload[VERANSTALTUNGEN_MANDANT_OPTIONS] !== null) {
                veranstaltungenConfig = a.payload[VERANSTALTUNGEN_MANDANT_OPTIONS];
            }

            let pandemieConfig: PandemieMandantOptions = Object.assign({}, state.pandemieConfig);
            if (a.payload[PANDEMIE_MANDANT_OPTIONS] !== undefined && a.payload[PANDEMIE_MANDANT_OPTIONS] !== null) {
                pandemieConfig = a.payload[PANDEMIE_MANDANT_OPTIONS];
            }

            let incidentAnzeigeConfig: IncidentsAnzeigeMandantOptions = Object.assign({}, state.incidentAnzeigeConfig);
            if (a.payload[INCIDENTS_ANZEIGE_MANDANT_OPTIONS] !== undefined && a.payload[INCIDENTS_ANZEIGE_MANDANT_OPTIONS] !== null) {
                incidentAnzeigeConfig = a.payload[INCIDENTS_ANZEIGE_MANDANT_OPTIONS];
            }

            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: false,
                stammConfig,
                lizenzConfig,
                mandantId,
                vorlagenConfig,
                veranstaltungenConfig,
                pandemieConfig,

                incidentAnzeigeConfig
            });
        }

        case GET_MANDANT_CONFIG_FEHLER: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: true
            });
        }

        // MandantLogo
        case GET_MANDANT_LOGO_BASE64_SCALED: {
            return Object.assign({}, state, <PageState> {
                mandantLogoLaden: true,
                mandantLogoFehler: false
            });
        }

        case GET_MANDANT_LOGO_BASE64_SCALED_ERFOLGREICH: {
            const a = <GetMandantLogoBase64ScaledErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                mandantLogo: a.payload,
                mandantLogoLaden: false,
                mandantLogoFehler: false
            });
        }

        case GET_MANDANT_LOGO_BASE64_SCALED_FEHLER: {
            return Object.assign({}, state, <PageState> {
                mandantLogoLaden: false,
                mandantLogoFehler: true
            });
        }

        case actionsUi.STAMM_CONFIG_INPUT: {
            const a = <actionsUi.StammConfigInput> action;

            return Object.assign({}, state, <PageState> {
                stammConfig: a.payload
            });
        }

        case actionsUi.VORLAGEN_CONFIG_INPUT: {
            const a = <actionsUi.VorlagenConfigInput> action;

            return Object.assign({}, state, <PageState> {
                vorlagenConfig: a.payload
            });
        }

        case actionsUi.INCIDENT_ANZEIGE_CONFIG_INPUT: {
            const a = <actionsUi.IncidentAnzeigeConfigInput> action;

            return Object.assign({}, state, <PageState> {
                incidentAnzeigeConfig: a.payload
            });
        }

        case actionsUi.PANDEMIE_CONFIG_INPUT: {
            const a = <actionsUi.PandemieConfigInput> action;

            return Object.assign({}, state, <PageState> {
                pandemieConfig: a.payload
            });
        }

        default: {
            return state;
        }
    }
}
